import { Box, CircularProgress, IconButton, TextField } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { Conversation } from '@types'
import { Send } from '@material-ui/icons'
import { useState } from 'react'
import { useSnackbar } from 'notistack'
import { postNewConversationAndRefresh } from '@views/tracking/state/trackingSlice2'

interface Props {
  conversations: Conversation[]
  type: string
  userId: string
  label: string
}

const ConversationBox: React.FC<Props> = ({ conversations, type, userId, label }) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [newConversation, setNewConversation] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const sendMessage = async () => {
    setIsLoading(true)

    await dispatch(
      postNewConversationAndRefresh({
        value: newConversation,
        userId,
        type
      })
    )

    enqueueSnackbar('Cambios guardados', { variant: 'success' })
    setIsLoading(false)
    setNewConversation('')
  }

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        padding="20px"
        border="1px solid #ccc"
        borderRadius="5px"
        bgcolor="#fff"
      >
        {isLoading ? (
          <Box display="flex" alignItems="center" justifyContent="center">
            <CircularProgress size={20} />
          </Box>
        ) : (
          <>
            {conversations
              .filter(i => i.type === type)
              .map(
                (message, index) =>
                  message.value && (
                    <>
                      <Box
                        key={index}
                        display="flex"
                        flexDirection="column"
                        mb={1}
                        p={1}
                        bgcolor="#ffebd9"
                        borderRadius="5px"
                        boxShadow="0 2px 4px rgba(0, 0, 0, 0.1)"
                      >
                        <Box fontSize="0.6rem" fontWeight="bold" marginBottom="0.5rem">
                          {message.authorName}:
                        </Box>
                        <Box whiteSpace="pre-line">{message.value}</Box>
                        <Box fontSize="0.6rem" color="#fc6404" display="flex" justifyContent="flex-end" width="100%">
                          {new Date(message.date).toISOString().split('T')[0]}
                        </Box>
                      </Box>
                    </>
                  )
              )}
          </>
        )}
        <Box display="flex" alignItems="center" justifyContent="center">
          <TextField
            size="small"
            fullWidth
            multiline
            label={label}
            variant="outlined"
            margin="normal"
            value={newConversation}
            disabled={isLoading}
            onChange={e => setNewConversation(e.target.value)}
          />
          <IconButton
            style={{
              color: '#ff6900',
              width: '10px',
              height: '10px',
              margin: '0 10px'
            }}
            disabled={isLoading}
            onClick={sendMessage}
          >
            <Send />
          </IconButton>
        </Box>
      </Box>
    </>
  )
}

export default ConversationBox
